import axios from 'axios'


function removeUndefined(obj) {
  Object.keys(obj).forEach((key) => {
    if ((obj[key] === undefined) || (obj[key] === "")) {
      delete obj[key]
    }
  });
  return obj
}
function downloadFile(url, file, type, params) {
  const options = {
    headers: {'accept': type},
    responseType: 'blob',
    params
  };

  return axios.get(url, options).then(response => {
    const blob = new Blob([(response.data)], {type: type});
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.id = 'tmp-file-download';
    anchor.setAttribute('download', file);
    document.body.appendChild(anchor);
    anchor.click();
    document.getElementById(anchor.id).remove();
  });
}

function setBodyInfo(note, status, key, storeKey, basketId) {

  let timestamp = new Date().getTime();
  return {
    timestamp: timestamp,
    key: key,
    type: 'customerUnpaidInvoiceInfo',
    data: {
      note: note,
      status: status,
      storeKey: storeKey,
      basketId: basketId

    }

  }
}

export default {
  findAllCustomers: (filters) => axios.get(`/api/sensei/customer`, {params: removeUndefined(filters) }).then(resp => resp.data),
  downloadCsvCustomer: (filters) => downloadFile(`/api/sensei/customer`, 'utenti_sensei.csv', 'text/csv', removeUndefined(filters)),
  findCustomerBy: (key) => axios.get(`/api/sensei/customer/detail`, {params: {key} }).then(resp => resp.data),
  findAllCharges: (filters) => axios.get(`/api/sensei/charges`, {params: removeUndefined(filters)}).then(resp => resp.data),
  customerHistory: (key) => axios.get(`/api/sensei/customer/${key}/history`).then(resp => resp.data),
  findAllUnpaidInvoices: (page, pageSize) => axios.get(`/api/sensei/unpaid-invoice`, {params: {page, pageSize}}).then(resp => resp.data),
  findAllUnpaidInvoicesFiltered: (filters, page, pageSize) => axios.get(`/api/sensei/unpaid-invoice`, {params: {filters, page, pageSize}}).then(resp => resp.data),
  setInfo: (note,status , key, storeKey, basketId) => axios.post(`/api/sensei/unpaid-invoice-info`, setBodyInfo(note, status , key, storeKey, basketId)),
  downloadCsvCharges: (filters) => downloadFile(`/api/sensei/charges`, 'pagamenti_completati_sensei.csv', 'text/csv', removeUndefined(filters)),
  downloadCsvUnpaidInvoices: () => downloadFile(`/api/sensei/unpaid-invoice`, 'pagamenti_non_completati_sensei.csv', 'text/csv', ),
  downloadFilteredCsvUnpaidInvoices: (filters) => downloadFile(`/api/sensei/unpaid-invoice`, 'pagamenti_non_completati_sensei.csv', 'text/csv',  {filters: filters}),
}
